import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { CountriesResponse } from "../slices/countries/types";

const api = new APIClient();

// Check if we should use the fake backend
export const getAllCountries = (
  pageNumber: number = 1,
  pageSize: number = 50
): Promise<CountriesResponse> => {
  
  // Real API call with query parameters
  return api.get(url.GET_COUNTRIES, {
    pageNumber,
    pageSize,
  }) as unknown as Promise<CountriesResponse>;
};
